export enum ExcelExportFileName {
    ACTIVITIYLOGS = 'ActivityLogs',
    ASSET = 'Références',
    EMAILTEMPLATE = 'Templates',
    GROUP = 'Groupes',
    IMPORTHISTORY = 'ImportHistory',
    IMPORTHISTORYDETAIL = 'ImportHistoryDetail',
    RECIPIENTENTITY = 'Sociétés',
    USER = 'Utilisateurs',
    WORKFLOW = 'Workflows',
    FAULTEDINVOICES = 'FaultedInvoices',
    APPROVAL = 'approvals',
    USERGROUPS = 'Groupes_Utilisateur',
    WORKFLOW_PROMOTION = "workflows_promotion"
}